import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [tipoIncentivo, setTipoIncentivo] = useState([]);
  const [candadoIncentivo, setCandadoIncentivo] = useState([]);
  const [categories, setCategories] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listTipoIncentivo() {
    let response = await wsFindBy('sale/tipo-incentivo');
    if (response.success) setTipoIncentivo(response.data);
  }
  async function listCandadoIncentivos() {
    let response = await wsFindBy('sale/candado-softy');
    if (response.success) setCandadoIncentivo(response.data);
  }
  async function listCategories() {
    let response = await wsFindBy('logi/category', { base_business_partner_id: 10 });
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        CodigoCategoria: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            CodigoCategoria: item.CODIGOCATEGORIA,
            tipo: (item.TIPO.toString()).toUpperCase(),
            zonal: item.ZONA,
            cuota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.CodigoCategoria) {
      setDataChanging((prev) => ({
        ...prev,
        CodigoCategoria: bPartnerSelect?.CodigoCategoria || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listTipoIncentivo();listCategories();listCandadoIncentivos();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo grupo de incentivos`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={'sale/softy-grupo'}
        dataForce={{
          // description: dataChanging.description,
          tipo_incentivo_id: dataChanging.tipo_incentivo_id,
          incentivo_candado_id: dataChanging.incentivo_candado_id,
        }}
      >
        <>
          <TextField
            label="Periodo"
            fullWidth
            type="month"
            name="periodo"
            margin="normal"
            defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
            InputLabelProps={{ shrink: true }}
            inputProps={{ readOnly: true }}
            required
          />
          <Autocomplete
            disableClearable
            options={tipoIncentivo}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Tipo Incentivo" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('tipo_incentivo_id', item?.id);}}
            value={tipoIncentivo.find((incentivo) => incentivo.id === dataChanging.tipo_incentivo_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <Autocomplete
            disableClearable
            options={candadoIncentivo}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Candado incentivo" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('incentivo_candado_id', item?.id);}}
            value={candadoIncentivo.find((candados) => candados.id === dataChanging.incentivo_candado_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <TextField
            label="Código"
            fullWidth
            type="text"
            name="code"
            margin="normal"
            value={dataChanging.code || ''}
            onChange={(e) => handleChange('code', e.target.value)}
            required
          />
          <TextField
            label="Descripción"
            fullWidth
            type="text"
            name="description"
            margin="normal"
            value={dataChanging.description || ''}
            onChange={(e) => handleChange('description', e.target.value)}
            required
          />
          <TextField
            label="Cuota"
            fullWidth
            type="number"
            name="importe_incentivo"
            margin="normal"
            value={dataChanging.importe_incentivo || ''}
            onChange={(e) => handleChange('importe_incentivo', e.target.value)}
            required
          />
        </>
      </Modal>
    </>
  );
});
